/**
 *
 * AppVerifyStepThree Component
 *
 */

import {
  Button,
  Enums,
  stylize,
  TextField,
} from "@envestnet/envreact-component-library";
import classnames from "classnames";
import React from "react";
import withIntl from "utils/withIntl";
import { StatusTypeEnum } from "./enums";
import messages from "./messages";
import styles, { Styles } from "./styles";
import { StatusType } from "./types";

const { ButtonSize, ButtonStyle } = Enums;

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;

  /** Internal - injected from WithStyles */
  innerRef?: React.RefObject<HTMLDivElement>;

  onCancel: Function;
  onNext: Function;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below

  /** Description of this prop */
  secretCode: string;
  status: StatusType;
}
export interface AppVerifyStepThreeProps extends DefaultProps {
  /** CSS class name to be applied to top level component */
  className?: string;

  /** Inline style object to be applied to top level component */
  style?: React.CSSProperties;
}

const defaultProps: DefaultProps = {
  secretCode: "",
  status: StatusTypeEnum.INITIAL,
};

type Props = InjectedProps & AppVerifyStepThreeProps;

const AppVerifyStepThree = (props: Props) => {
  const {
    classes,
    style,
    className,
    formatMessage,
    innerRef,
    onCancel,
    secretCode,
    onNext,
    status,
  } = props;

  const [key, setKey] = React.useState(secretCode);

  return (
    <div
      ref={innerRef}
      className={classnames(className, classes.container)}
      style={style}
    >
      <div className={classnames(classes.descClass, "header-text-font-family")}>
        {formatMessage(messages.header)}
      </div>
      <div className={classnames(classes.infoClass, "header-text-font-family")}>
        {formatMessage(messages.info)}
      </div>
      <div data-testid="okta-verify-step-two-code-input">
        <TextField
          label={formatMessage(messages.keyTextField)}
          text={key.match(/.{1,4}/g)?.join("  ")}
          onChangeText={(text) => setKey(text)}
          textStyle={{fontFamily: "Red Hat Text"}}
          className={classnames(
            classes.textfield,
            "header-font-family",
            "no-border-radius"
          )}
          disabled
          textFieldStyle={classes.disabledTextField}
          aria-label="secret code textfield"
        />
      </div>
      <div>
        <Button
          buttonStyle={ButtonStyle.Primary}
          buttonSize={ButtonSize.Regular}
          className={classnames(classes.verifyButton, "no-border-radius", "header-text-font-family")}
          name={formatMessage(messages.nextButtonLabel)}
          onClick={() => onNext()}
          loading={status === StatusTypeEnum.PROCESSING}
          aria-label="next button"
        />
      </div>
      <div>
        <Button
          buttonStyle={ButtonStyle.Link}
          buttonSize={ButtonSize.Regular}
          className={classnames(classes.linkButton, "header-text-font-family")}
          name={formatMessage(messages.cancelButtonLabel)}
          onClick={() => onCancel()}
          aria-label="cancel button"
        />
      </div>
    </div>
  );
};

AppVerifyStepThree.defaultProps = defaultProps;

export default withIntl(
  stylize<Props, DefaultProps>(styles)(AppVerifyStepThree)
);
